import { FunctionalComponent, h } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";

interface LocationThumbnailProps {
    name: string;
    street1: string;
    street2: string;
    postcode: string;
    imageType: string | null;
    tel: string | null;
    email: string | null;
    city: string;
    link: string;
    baseClass: string;
}

const { t } = i18nProvider;

export const LocationThumbnail: FunctionalComponent<LocationThumbnailProps> = ({
    name,
    street1,
    street2,
    link,
    postcode,
    imageType,
    tel,
    email,
    city,
    baseClass,
}) => (
    <div class={`${baseClass}__location-thumbnail`}>
        {imageType && (
            <div class={`${baseClass}__location-thumbnail-img`}>
                <img src={imageType} alt="" />
            </div>
        )}
        <div class={`${baseClass}__location-thumbnail-content`}>
            <div class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                {name}
            </div>
            <div class="ux-text-tiny">
                {street1}
                {street2 ? `, ${street2}` : ``}
            </div>
            <div class="ux-text-tiny">
                {postcode} {city}
            </div>
            {tel && <div class="ux-text-tiny">{tel}</div>}
            {email && (
                <div class="ux-text-tiny">
                    <a href={`mailto:${email}`} class="ux-text-link">
                        {email}
                    </a>
                </div>
            )}
        </div>
        <div class={`${baseClass}__location-thumbnail-cta`}>
            <a
                class="ux-button ux-button--icon-only"
                href={link}
                aria-label={t("locationMap.locationLink.label")}
                role="button"
            >
                <ux-icon name="chevron-right"></ux-icon>
            </a>
        </div>
    </div>
);
